import { Suspense, useCallback } from 'react'
import React from 'react'
import { TourToolTip } from './TourToolTip'

const Joyride = React.lazy(() => import('react-joyride'))

const steps = [
    {
        target: '[data-info="search"]',
        content: [
            {
                text: 'Search for',
                subText: [
                    'Who: People and profiles',
                    'What: Projects and applications',
                    ' How: Files in ASK and Innovation Pillar, or other SharePoint locations',
                ],
            },
            {
                text: 'Type to see suggestions, and press enter to see more results',
                subText: [],
            },
        ],
        disableBeacon: true,
        title: 'Search',
    },
    {
        target: '[data-info="notifications"]',
        content: [
            'User Notifications',
            'A Green Dot Appears on the bell icon indicating new notifications',
            'Click on the bell icon to view the notifications',
            'Click on the notification to view the details',
        ],
        disableBeacon: true,
        title: 'Notifications',
    },
    {
        target: '[data-info="feedback"]',
        content: [
            'Application Level Feedback',
            'Click on this icon to provide Application level feedback',
            'Feedback can be provided for each page / application being accessed',
            'The Konnnect Portal provides access to multiple applications and each application has its own feedback form',
            'Like , Dislike, Comment options available to provide feedback',
        ],
        disableBeacon: true,
        title: 'Application Feedback',
    },
    {
        target: '[data-info="account"]',
        content: [
            'User Account Information',
            'View your profile, settings, and logout',
        ],
        disableBeacon: true,
        title: 'User Account',
    },
    {
        target: '[data-info="home"]',
        content: [
            'This is your initial page where you can see recent apps and search in ASK',
        ],
        disableBeacon: true,
        title: 'Home Tab',
    },
    {
        target: '[data-info="side-nav"]',
        content: [
            'Based on the user role, the side navigation will be different',
            'Click on the side navigation to view the respective applications you have access to',
            'Provide Application Level Feedback',
            'Access different applications in one unified portal',
            'As new applications are added, the side navigation will be updated based on the user role',
            'If there are more applications the "..." icon will appear',
            'Click on the "..." icon to view more applications you have access to',
        ],
        disableBeacon: true,
        title: 'Application Selection Navigation Side Bar',
    },
    {
        target: '[data-info="settings"]',
        content: [
            'View all the user preferences and feedback data for the portal',
            'Click on the specific tabs for more details',
        ],
        disableBeacon: true,
        title: 'Settings',
    },
]
export interface ProductTourProps {
    onClose: (isLastStep: boolean) => void
    run: boolean
}

export const TourDetails: React.FC<ProductTourProps> = ({ onClose, run }) => {
    const handleJoyrideCallback = useCallback((data: any) => {
        const { status, action } = data
        if (
            ['finished', 'skipped'].includes(status) ||
            ['close'].includes(action)
        ) {
            const isLastStep = status === 'finished'
            onClose(isLastStep)
        }
    }, [])

    return (
        <div className="h-screen">
            <Suspense fallback={<div>Loading...</div>}>
                <Joyride
                    steps={steps}
                    run={run}
                    continuous={true}
                    showProgress={true}
                    scrollToFirstStep={true}
                    disableScrolling={true}
                    tooltipComponent={TourToolTip}
                    callback={handleJoyrideCallback}
                    styles={{
                        options: {
                            zIndex: 9999999999,
                            primaryColor: '#ff6a12',
                        },
                    }}
                />
            </Suspense>
        </div>
    )
}
